import { render, staticRenderFns } from "./remove.vue?vue&type=template&id=138ca82c&scoped=true&"
import script from "./remove.vue?vue&type=script&lang=js&"
export * from "./remove.vue?vue&type=script&lang=js&"
import style0 from "./remove.vue?vue&type=style&index=0&id=138ca82c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ca82c",
  null
  
)

export default component.exports